import request from '@/utils/request.js'
const base = '/sys/'

// 获取usdt转usd汇率
export function getUsdtUsdRate() {
  return request.get(base + 'usdt_usd')
}



// WEBPACK FOOTER //
// ./src/api/sys.js